import { addNavMenuItem, registerBulkAction } from "@bb-vendure/admin-ui/core";
import { bulkDeleteAction } from "./components/bulkAction";

export default [
  addNavMenuItem(
    {
      id: "service-fee",
      label: "nav.service-fee",
      routerLink: ["/extensions/service-fee"],
      icon: "coin-bag",
      requiresPermission: (userPermissions) =>
        userPermissions.includes("ReadServiceFee"),
    },
    "settings"
  ),

  registerBulkAction(bulkDeleteAction),
];
